import type { LicenseStatus } from '../types';

// Status tone is used as a SCSS modifier to color the chip. Keep the palette
// in sync with CompanySwitcher.module.scss / CompaniesLanding.module.scss.
export type StatusTone = 'ok' | 'warn' | 'bad' | 'neutral';

export const statusTone = (status: LicenseStatus): StatusTone => {
  switch (status) {
    case 'active':
      return 'ok';
    case 'expiring_soon':
      return 'warn';
    case 'expired':
    case 'suspended':
      return 'bad';
    default:
      return 'neutral';
  }
};

export interface FeatureBadge {
  key: string;
  i18nKey: string; // under common → license.feature.*
}

// Minimal shape we need to render feature badges; both UserCompany and
// AdminCompany satisfy it (structural typing).
export interface CompanyWithFeatures {
  has_brand_protection: boolean;
  has_continuous_red_team: boolean;
}

// CTEM is implicit for every plan, so only optional features need badges.
export const featureBadgesForCompany = (c: CompanyWithFeatures): FeatureBadge[] => {
  const badges: FeatureBadge[] = [];
  if (c.has_continuous_red_team) {
    badges.push({ key: 'continuous_red_team', i18nKey: 'license.feature.continuous_red_team' });
  }
  if (c.has_brand_protection) {
    badges.push({ key: 'brand_protection', i18nKey: 'license.feature.brand_protection' });
  }
  return badges;
};
